import { combineReducers } from "redux";
//import UIReducer from './UIReducer'
import TableReducer from "./TableReducer";
import MessageReducer from "./MessageReducer";
import AuthReducer from "../../../Shared/Redux/Reducers/AuthReducer";
const rootReducer = combineReducers({ TableReducer, MessageReducer, AuthReducer });

export default rootReducer;
